import './style.scss';
import Swiper from "swiper";
import { Autoplay, Navigation } from "swiper/modules";

Swiper.use([Autoplay, Navigation]);

export function gallery_block() {
  const block = document.querySelector('.gallery_block');
  if (!block) return;

  const mainEl = block.querySelector('.main-swiper');
  const controlEl = block.querySelector('.control-swiper');
  const progressFill = block.querySelector('.progress-bar-fill');
  const nextBtn = block.querySelector('.swiper-button-next');
  const prevBtn = block.querySelector('.swiper-button-prev');
  let controlSwiper = null;

  if (!mainEl || !progressFill) return;

  const AUTOPLAY_TIME = 5000;

  function resetProgressBar() {
    progressFill.style.transition = 'none';
    progressFill.style.width = '0%';
  }

  const mainSwiper = new Swiper(mainEl, {
    loop: true,
    speed: 600,

    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },

    // ❌ Disable autoplay initially
    autoplay: false,

    on: {
      init() {
        resetProgressBar();
        requestAnimationFrame(() => {
          updateActiveThumb(this);
        });
      },

      slideChange() {
        updateActiveThumb(this);
      },

      slideChangeTransitionStart() {
        resetProgressBar();
      },

      autoplayTimeLeft(swiper, timeLeft, progress) {
        progressFill.style.width = `${(1 - progress) * 100}%`;
      }
    }
  });

  // Control Swiper (thumbs)
  if (controlEl) {
    controlSwiper = new Swiper(controlEl, {
      slidesPerView: 'auto',
      loop: true,
      watchSlidesProgress: true,
      on: {
        click(sw) {
          if (sw.clickedIndex !== undefined) {
            mainSwiper.slideToLoop(sw.clickedIndex);
          }
        }
      }
    });
  }

  function updateActiveThumb(swiper) {
    if (!controlSwiper) return;

    const realIndex = swiper.realIndex;

    controlSwiper.slides.forEach(slide => {
      slide.classList.remove('swiper-slide-thumb-active');
    });

    const activeThumb = controlSwiper.slides[realIndex];
    if (activeThumb) {
      activeThumb.classList.add('swiper-slide-thumb-active');
      controlSwiper.slideTo(realIndex);
    }
  }

  /* ----------------------------------
     INTERSECTION OBSERVER
  ---------------------------------- */

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {

        if (entry.isIntersecting) {
          // Start autoplay
          mainSwiper.params.autoplay = {
            delay: AUTOPLAY_TIME,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          };

          mainSwiper.autoplay.start();

        } else {
          // Stop autoplay when out of view
          mainSwiper.autoplay.stop();
          resetProgressBar();
        }

      });
    },
    {
      threshold: 0.5 // 50% visible before triggering
    }
  );

  observer.observe(block);
}
